import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Payment terms in days for invoice payment.
 */
export const schema = z.number().int().min(1).max(30);

export type PaymentTerms = z.infer<typeof schema>;

export const definition = define({
  key: 'payment_terms',
  kind: DEFINITION_KINDS.SETTING,
  schema,
  writableAtLevels: [LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  label: 'Payment Terms',
  description:
    "Payment terms determine how many days we give the client to pay an invoice after it's end date. This should be set to 30 days, unless the client specifically requests otherwise.",
  category: CATEGORIES.BILLING.key,
  defaultValue: 30,

  storage: {
    levels: {
      customer: {
        type: 'dedicated_column',
        table: 'customers',
        column: 'payment_terms',
        valueType: 'numeric',
      },
    },
  },
});
